import { SocialSignUpType } from "../../../api/types/social.type";
import { translationsContent } from "../../../localization/translations";
import { useLanguage } from "../../../store/lang.context";
import { translate } from "../../../utils/translate";
import SimpleModal from "../../ui/modal/SimpleModal/index";
import SignupForm from "./Form";
import classes from "./signup.module.scss";

interface Props {
  setSignUpIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setLoginIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSocialSignUp: React.Dispatch<React.SetStateAction<SocialSignUpType>>;
}

const Signup = ({
  setSignUpIsOpen,
  setLoginIsOpen,
  setSocialSignUp,
}: Props) => {
  const { language } = useLanguage();
  return (
    <SimpleModal setModalIsOpen={setSignUpIsOpen}>
      <div className={classes.container} id="signUpPage">
        <div className={classes.modalHeader}>
          <h2 className={classes.heading}>
            {translate(translationsContent, "signupHeader1", language)}
          </h2>
        </div>
        <SignupForm
          setSocialSignUp={setSocialSignUp}
          setLoginIsOpen={setLoginIsOpen}
          setSignUpIsOpen={setSignUpIsOpen}
        />
      </div>
    </SimpleModal>
  );
};

export default Signup;
